// src/pages/Formation.js
// Deux listes distinctes, bâties sur le même modèle :
//   /encadrants : les arbitres qui encadrent la formation
//   /diplomes   : les personnes admises à la formation
// Données : GET {BASE_URL}/api/formation-membres?type=... (ERP, menu DAJC > Membres de la formation).
import React from "react";
import { Link, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BASE_URL from "../config";
import { localePath } from "../utils/content";
import { tf } from "../utils/formation";
import Seo from "../components/Seo";
import MembresFormation from "../components/MembresFormation/MembresFormation";

const PATHS = { encadrant: "encadrants", participant: "diplomes" };
const MENU_KEYS = { encadrant: "menu.encadrants", participant: "menu.diplomes" };

export default function Formation({ type = "encadrant" }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const path = PATHS[type] || PATHS.encadrant;
  const title = tf(t, lang, `formation.pages.${type}.title`);
  const subtitle = tf(t, lang, `formation.pages.${type}.subtitle`);

  return (
    <>
      <Seo
        path={path}
        title={title}
        description={subtitle}
        breadcrumb={[
          { name: t("common.home"), path: "" },
          { name: tf(t, lang, MENU_KEYS[type]), path },
        ]}
      />

      <section className="page-header">
        <div className="container">
          <div className="page-header__inner">
            <div className="page-header__crumbs">
              <Link to={localePath(lang)}>{t("common.home")}</Link>
              <span>/</span>
              <span>{t("menu.arbitrage")}</span>
              <span>/</span>
              <span>{title}</span>
            </div>
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
        </div>
      </section>

      <section className="dajc-formation" style={{ background: "var(--ivory)" }}>
        <div className="container">
          <MembresFormation
            lang={lang}
            apiBaseUrl={BASE_URL}
            type={type}
            showHeader={false}
            title={title}
          />
        </div>
      </section>
    </>
  );
}

/** Ancienne adresse /formation : renvoie vers la liste des encadrants. */
export function FormationRedirect() {
  const { i18n } = useTranslation();
  return <Navigate to={localePath(i18n.language, PATHS.encadrant)} replace />;
}
